{
    "title": "Plato fragen",
    "trigger": "Plato fragen",
    "close": "Plato fragen schließen",
    "send": "Senden",
    "scroll_to_bottom": "Zum Ende scrollen",
    "thinking": "Denkt nach …",
    "placeholder": "Frag nach Kunden, Umsatz, Aufgaben…",
    "error": "Etwas ist schiefgelaufen.",
    "like": "Antwort positiv bewerten",
    "dislike": "Antwort negativ bewerten",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "disclaimer": "Plato fragen ist experimentell und kann Fehler machen. Bitte überprüfe wichtige Informationen.",
    "ask_support": "Support kontaktieren",
    "retry": "Erneut versuchen",
    "support_message": "Plato fragen konnte diese Frage nicht beantworten:\n\n{{question}}\n\n",
    "error_explanation": "Es gibt gerade ein technisches Problem bei mir. Versuche es später noch einmal oder wende dich direkt an unseren Support.",
    "welcome": "Hallo! Ich kenne deine Kunden, Aufträge und Aktivitäten. Was möchtest du wissen?",
    "teaser": "Fragen? Plato hilft!",
    "teaser_dismiss": "Hinweis ausblenden",
    "new_chat": "Neuer Chat",
    "context_limit_reached": "Gesprächslimit erreicht.",
    "context_limit_reached_explanation": "Diese Unterhaltung hat ihre maximale Länge erreicht. Starte einen neuen Chat, um weiterzumachen.",
    "start_new_chat": "Neuen Chat starten",
    "history": "Verlauf",
    "history_empty": "Noch keine Unterhaltungen.",
    "back": "Zurück zum Chat",
    "history_today": "Heute",
    "history_yesterday": "Gestern",
    "history_last_7_days": "Letzte 7 Tage",
    "history_older": "Älter",
    "tool__generic__running": "Wird bearbeitet",
    "tool__generic__done": "Geschäftsdaten abgerufen",
    "tool__failed": "Daten konnten nicht abgerufen werden",
    "tool__interrupted": "Vor Abschluss abgebrochen",
    "tool__find_plato_page__running": "Sucht die passende Stelle in Plato",
    "tool__find_plato_page__done": "Passende Stelle in Plato gesucht",
    "tool__get_customer_notes__running": "Liest Notizen",
    "tool__get_customer_notes__done": "Notizen gelesen",
    "tool__get_customer_notes__done_search": "Notizen zu „{{search}}“ gelesen",
    "tool__get_pinned_customer_notes__running": "Liest angeheftete Notizen",
    "tool__get_pinned_customer_notes__done": "Angeheftete Notizen gelesen",
    "tool__get_note__running": "Liest eine Notiz",
    "tool__get_note__done": "Notiz gelesen",
    "tool__get_data_freshness__running": "Prüft die Aktualität der Daten",
    "tool__get_data_freshness__done": "Aktualität der Daten geprüft",
    "tool__get_daily_order_intake__running": "Prüft den Auftragseingang von heute und gestern",
    "tool__get_daily_order_intake__done": "Auftragseingang von heute und gestern geprüft",
    "tool__get_sales_summary__running": "Liest die Umsatzübersicht für das laufende Jahr",
    "tool__get_sales_summary__done": "Umsatzübersicht für das laufende Jahr gelesen",
    "tool__get_sales_totals__running": "Berechnet Umsatzsummen",
    "tool__get_sales_totals__done": "Umsatzsummen berechnet",
    "tool__get_monthly_trend__running": "Lädt den monatlichen Umsatzverlauf",
    "tool__get_monthly_trend__done": "Monatlichen Umsatzverlauf geladen",
    "tool__get_revenue_by_year__running": "Vergleicht den Umsatz über mehrere Jahre",
    "tool__get_revenue_by_year__done": "Umsatz über mehrere Jahre verglichen",
    "tool__get_top_customers__running": "Erstellt Rangliste der Kunden",
    "tool__get_top_customers__done": "Rangliste der Kunden erstellt",
    "tool__get_top_customers__done_search": "Rangliste der Kunden zu „{{search}}“ erstellt",
    "tool__get_top_products__running": "Erstellt Rangliste der Artikel",
    "tool__get_top_products__done": "Rangliste der Artikel erstellt",
    "tool__get_top_products__done_search": "Rangliste der Artikel zu „{{search}}“ erstellt",
    "tool__get_top_product_groups__running": "Erstellt Rangliste der Produktgruppen",
    "tool__get_top_product_groups__done": "Rangliste der Produktgruppen erstellt",
    "tool__get_top_product_groups__done_search": "Rangliste der Produktgruppen zu „{{search}}“ erstellt",
    "tool__get_top_categories__running": "Erstellt Rangliste der Warengruppen",
    "tool__get_top_categories__done": "Rangliste der Warengruppen erstellt",
    "tool__get_top_categories__done_search": "Rangliste der Warengruppen zu „{{search}}“ erstellt",
    "tool__get_top_suppliers__running": "Erstellt Rangliste der Lieferanten",
    "tool__get_top_suppliers__done": "Rangliste der Lieferanten erstellt",
    "tool__get_top_suppliers__done_search": "Rangliste der Lieferanten zu „{{search}}“ erstellt",
    "tool__get_top_clerks__running": "Erstellt Rangliste der Erfasser",
    "tool__get_top_clerks__done": "Rangliste der Erfasser erstellt",
    "tool__get_top_clerks__done_search": "Rangliste der Erfasser zu „{{search}}“ erstellt",
    "tool__get_top_sales_reps__running": "Erstellt Rangliste der Vertreter",
    "tool__get_top_sales_reps__done": "Rangliste der Vertreter erstellt",
    "tool__get_top_sales_reps__done_search": "Rangliste der Vertreter zu „{{search}}“ erstellt",
    "tool__get_top_storage_locations__running": "Erstellt Rangliste der Lager",
    "tool__get_top_storage_locations__done": "Rangliste der Lager erstellt",
    "tool__get_top_storage_locations__done_search": "Rangliste der Lager zu „{{search}}“ erstellt",
    "tool__get_top_industries__running": "Erstellt Rangliste der Branchen",
    "tool__get_top_industries__done": "Rangliste der Branchen erstellt",
    "tool__get_top_industries__done_search": "Rangliste der Branchen zu „{{search}}“ erstellt",
    "tool__get_customer_details__running": "Liest Kundendetails",
    "tool__get_customer_details__done": "Kundendetails gelesen",
    "tool__get_customer_financials__running": "Liest Kundenkennzahlen",
    "tool__get_customer_financials__done": "Kundenkennzahlen gelesen",
    "tool__get_customer_segment_aggregates__running": "Wertet ein Kundensegment aus",
    "tool__get_customer_segment_aggregates__done": "Kundensegment ausgewertet",
    "tool__get_quotes_orders_aggregates__running": "Summiert Angebote und Aufträge",
    "tool__get_quotes_orders_aggregates__done": "Angebote und Aufträge summiert",
    "tool__get_team_members__running": "Lädt die Teamliste",
    "tool__get_team_members__done": "Teamliste geladen",
    "tool__get_team_overview__running": "Erstellt die Team-Aktivitätsübersicht",
    "tool__get_team_overview__done": "Team-Aktivitätsübersicht erstellt",
    "tool__get_team_overview__done_search": "Team-Aktivitätsübersicht für „{{search}}“ erstellt",
    "tool__get_team_stats__running": "Berechnet die Team-Summen",
    "tool__get_team_stats__done": "Team-Summen berechnet",
    "tool__get_team_stats__done_search": "Team-Summen für „{{search}}“ berechnet",
    "home__greeting_morning": "Guten Morgen, {{name}}",
    "home__greeting_day": "Guten Tag, {{name}}",
    "home__greeting_evening": "Guten Abend, {{name}}",
    "home__plato_line": "Ich kenne deine Kunden, Aufträge und Aktivitäten. Was möchtest du wissen?",
    "home__composer_label": "Frage an Plato",
    "home__placeholder_short": "Frag Plato…",
    "home__voice_input": "Aufnahme starten",
    "home__starters_label": "Vorschläge",
    "home__starter_visit_prep_label": "Kundentermin vorbereiten",
    "home__starter_visit_prep": "Bereite mich auf meinen Termin bei {{caret}} vor",
    "home__starter_revenue_decline_label": "Kunden mit Umsatzrückgang",
    "home__starter_revenue_decline": "Welche meiner Kunden verlieren gerade Umsatz – und warum?",
    "home__starter_revenue_vs_last_year_label": "Mein Umsatz vs. Vorjahr",
    "home__starter_revenue_vs_last_year": "Wie läuft mein Umsatz dieses Jahr im Vergleich zum Vorjahr?"
}
